import { render, staticRenderFns } from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=template&id=4bb7574c&scoped=true&"
import script from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=style&index=0&id=4bb7574c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7574c",
  null
  
)

export default component.exports